import * as React from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router'
import { SupportSideMenu } from '../../components/Support'
import { BaseLayout } from '../../layouts'
import { UsefulResourcesPage, DocumentationPage } from '.'

const SupportRouter = (): React.ReactElement => {
  const { path } = useRouteMatch()
  return (
    <BaseLayout menu={<SupportSideMenu />}>
      <Switch>
        <Route path={`${path}`} exact>
          <Redirect to={`${path}/documentation`} />
        </Route>
        <Route path={`${path}/documentation`} exact>
          <DocumentationPage />
        </Route>
        <Route path={`${path}/useful-resources`} exact>
          <UsefulResourcesPage />
        </Route>
      </Switch>
    </BaseLayout>
  )
}

export default SupportRouter
